// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".actions * {\n  position: relative;\n  top: 1px;\n}[dir] .actions * {\n  cursor: pointer;\n}[dir=ltr] .actions * {\n  float: right;\n}[dir=rtl] .actions * {\n  float: left;\n}\n.wrap-versions {\n  max-height: 200px;\n  overflow: scroll;\n}\n[dir] .version {\n  padding: 4px;\n  border-bottom: 1px solid darkgray;\n}\n", ""]);
// Exports
module.exports = exports;
